/* eslint-disable @typescript-eslint/naming-convention */
import 'reflect-metadata';
import {FormElement, FormElementConfiguration} from 'app/entities/form/formElement.entity';
import {Type} from 'class-transformer';
import {FormElementType} from 'app/entities/enums';

export class FormElementToggle extends FormElement {
  type: FormElementType = 'toggle';

  @Type(() => FormElementToggleConfiguration)
  configuration?: FormElementToggleConfiguration = new FormElementToggleConfiguration();
}

export class FormElementToggleConfiguration extends FormElementConfiguration {
  label?: string = null;
}

